import * as n from "react";
import { Primitive as p } from "../../../../../@radix-ui_react-primitive@2.1.3_@types_react-dom@19.2.3_@types_react@19.2.14__@types_re_1181ea5061ec9212248424669240e4ec/bundled_deps/@radix-ui/react-primitive/dist/index.js";
import { j as o } from "../../../../../../../_virtual/jsx-runtime.js";
var v = "Arrow", e = n.forwardRef((r, i) => {
  const { children: t, width: s = 10, height: a = 5, ...m } = r;
  return /* @__PURE__ */ o.jsx(
    p.svg,
    {
      ...m,
      ref: i,
      width: s,
      height: a,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: r.asChild ? t : /* @__PURE__ */ o.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
e.displayName = v;
var h = e;
export {
  e as Arrow,
  h as Root
};
